module.exports = __webpack_public_path__ + "static/img/8.cada3ee.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/19/sp/8.png
// module id = fIzt
// module chunks = 0